const downloadProducts = document.querySelectorAll(".download-product");
const downloadProductInfo = document.querySelectorAll(
  ".download-product__info"
);

let clickedOnce = false;

downloadProducts.forEach((product, index) => {
  product.addEventListener("click", () => {
    // Remove classes from other products
    downloadProducts.forEach((item, i) => {
      if (i !== index) {
        item.classList.add("not-active-product");
        item.classList.add("small-hide");
        item.classList.remove("active-product");
      }
    });

    // Remove classes from other product info elements
    downloadProductInfo.forEach((item, i) => {
      if (i !== index) {
        item.classList.remove("download-visible");
      }
    });

    // Toggle class for clicked product
    product.classList.toggle("active-product");
    const isActive = product.classList.contains("active-product");

    if (isActive) {
      product.classList.remove("not-active-product");
    }

    if (!isActive) {
      downloadProducts.forEach((item, i) => {
        if (i !== index) {
          item.classList.remove("not-active-product");
          item.classList.remove("small-hide");
        }
      });
    }

    downloadProductInfo[index].classList.toggle("download-visible");

    clickedOnce = true;
  });
});
